var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isShow)?_c('el-image-viewer',{attrs:{"on-close":_vm.ViewerClose,"url-list":_vm.imgPathList}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }